import Swal from "sweetalert2";

export const confirmTreatmentApproval = (onConfirm) => {
    Swal.fire({
        title: "Confirmation",
        text: "Êtes-vous sûr de vouloir approuver cette demande ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#10b981",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Oui, approuver",
        cancelButtonText: "Annuler",
    }).then((result) => {
        if (result.isConfirmed) onConfirm();
    });
};
